import { useLazyQuery } from '@netfront/apollo-providers';

import { GET_PLANS_QUERY } from './useGetPlans.graphql';
import {
  IHandleGetPlansParams,
  IUseGetPlans,
  IUseGetPlansOptions,
} from './useGetPlans.interfaces';


const useGetPlans = (options?: IUseGetPlansOptions): IUseGetPlans => {
  const { fetchPolicy, onCompleted, onError } = options ?? ({} as IUseGetPlansOptions);

  const { handleQuery: executeGetPlans, isLoading = false } = useLazyQuery({
    apiName: 'muriqui',
    fetchPolicy: fetchPolicy ?? 'cache-and-network',
    onCompleted: (data) => {
      if (!onCompleted) {
        return;
      }

      const {
        plans: { getPlans: plans },
      } = data;

      onCompleted({
        plans,
      });
    },
    onError,
    query: GET_PLANS_QUERY,
  });

  const handleGetPlans = async (params?: IHandleGetPlansParams) => {
    const { currency = 'AUD' } = params ?? {};

    await executeGetPlans({
      currency,
      product: 'QUICKCODES',
    });
  };

  return {
    handleGetPlans,
    isLoading,
  };
};

export { useGetPlans };
